import { useEffect } from 'react';

import EmptyState from '@preqin/ui-components/cjs/core/EmptyState';

import { HTTPError } from '@/api/types';

import { fireHeapEvent } from '../../utils/heapUtil';

const message = (error?: HTTPError | string) => {
  if (typeof error === 'string') {
    return error;
  }

  if (error && 'message' in error && error.message !== 'Network Error') {
    return error.message;
  }

  return 'The requested page was not found';
};

export const ErrorNotification = ({ error }: { error?: HTTPError | string }) => {
  useEffect(() => {
    fireHeapEvent('Generic Error', {}, window.location.pathname);
  }, []);
  return <EmptyState header={message(error)} image={require('@preqin/ui-components/assets/gifs/NotFound.gif')} />;
};
